import React from 'react'
import PropTypes from 'prop-types'

import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'

import closeIcon from 'resources/close_icon.png'

const Actions = ({ onCancelClicked, onProceedClicked }) => {
  return (
    <div style={styles.actions}>
      <FlatButton
        label='Cancel'
        onTouchTap={onCancelClicked}/>
      <FlatButton
        primary={true}
        label='Proceed'
        onTouchTap={onProceedClicked}/>
    </div>
  )
}

Actions.propTypes = {
  onCancelClicked: PropTypes.func.isRequired,
  onProceedClicked: PropTypes.func.isRequired
}

const Header = ({ title, onCloseRequested }) => {
  return (
    <div style={styles.header}>
      <div style={styles.heading}>
        { title }
      </div>
      <div style={{ marginRight: 16 }}>
        <img src={closeIcon} title='Close' width={16}
          onClick={onCloseRequested}
          style={{ cursor: 'pointer', marginLeft: 8 }} />
      </div>
    </div>
  )
}

Header.propTypes = {
  title: PropTypes.string.isRequired,
  onCloseRequested: PropTypes.func.isRequired
}

export default class WarningDialog extends React.Component {

  static propTypes = {
    open: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    onCloseRequest: PropTypes.func.isRequired,
    onProceedClicked: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    if (!this.props.open) {
      return null
    }

    return (
      <Dialog open={this.props.open}
        onRequestClose={this.props.onCloseRequest}
        actions={
          <Actions
            onCancelClicked={this.props.onCloseRequest}
            onProceedClicked={this.props.onProceedClicked} />
        }
        title={<Header title={this.props.title} onCloseRequested={this.props.onCloseRequest} />}
        bodyStyle={styles.dialogBody}
        contentStyle={styles.dialogContent}
        actionsContainerStyle={{ padding: 0 }}>
        <div style={{...styles.inputContainer, ...styles.fieldDisplay}}>
          { this.props.message }
        </div>
      </Dialog>
    )
  }

}

const styles = {
  inputContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: 16
  },
  fieldDisplay: {
    color: '#4a4a4a',
    fontSize: 14
  },
  subheaderDisplay: {
    color: '#4a4a4a',
    fontSize: 14,
    marginBottom: 4,
    fontWeight: 500
  },
  dialogContent: {
    borderRadius: 4,
    // This is a hack as there is a bug in Dialog's definition to properly
    // apply the border radius.
    overflow: 'auto',
    width: 360
  },
  dialogBody: {
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    borderRadius: 4
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    height: 48,
    paddingRight: 16,
    backgroundColor: '#fafafa'
  },
  header: {
    display: 'flex',
    displayDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 48,
    backgroundColor: '#fafafa'
  },
  heading: {
    fontSize: 16,
    marginLeft: 16,
    color: '#212121'
  }
}



// WEBPACK FOOTER //
// ./src/customer/common/WarningDialog.js